import { CSSProperties } from 'react';

// US
import US_1_1 from './us/1-1.png';
import US_1_2 from './us/1-2.png';
import US_1_3 from './us/1-3.png';
import US_1_search from './us/1-search.png';
import US_2_1 from './us/2-1.png';
import US_2_2 from './us/2-2.png';
import US_2_3 from './us/2-3.png';
import US_2_search from './us/2-search.png';
import US_3_1 from './us/3-1.png';
import US_3_2 from './us/3-2.png';
import US_3_3 from './us/3-3.png';
import US_3_search from './us/3-search.png';

// JP
import JP_1_1 from './jp/1-1.png';
import JP_1_2 from './jp/1-2.png';
import JP_1_3 from './jp/1-3.png';
import JP_1_search from './jp/1-search.png';
import JP_2_1 from './jp/2-1.png';
import JP_2_2 from './jp/2-2.png';
import JP_2_3 from './jp/2-3.png';
import JP_2_search from './jp/2-search.png';
import JP_3_1 from './jp/3-1.png';
import JP_3_2 from './jp/3-2.png';
import JP_3_3 from './jp/3-3.png';
import JP_3_search from './jp/3-search.png';

// TH
import TH_1_1 from './th/1-1.png';
import TH_1_2 from './th/1-2.png';
import TH_1_3 from './th/1-3.png';
import TH_1_search from './th/1-search.png';
import TH_2_1 from './th/2-1.png';
import TH_2_2 from './th/2-2.png';
import TH_2_3 from './th/2-3.png';
import TH_2_search from './th/2-search.png';
import TH_3_1 from './th/3-1.png';
import TH_3_2 from './th/3-2.png';
import TH_3_3 from './th/3-3.png';
import TH_3_search from './th/3-search.png';

// ID
import ID_1_1 from './id/1-1.png';
import ID_1_2 from './id/1-2.png';
import ID_1_3 from './id/1-3.png';
import ID_1_search from './id/1-search.png';
import ID_2_1 from './id/2-1.png';
import ID_2_2 from './id/2-2.png';
import ID_2_3 from './id/2-3.png';
import ID_2_search from './id/2-search.png';
import ID_3_1 from './id/3-1.png';
import ID_3_2 from './id/3-2.png';
import ID_3_3 from './id/3-3.png';
import ID_3_search from './id/3-search.png';

// MY
import MY_1_1 from './my/1-1.png';
import MY_1_2 from './my/1-2.png';
import MY_1_3 from './my/1-3.png';
import MY_1_search from './my/1-search.png';
import MY_2_1 from './my/2-1.png';
import MY_2_2 from './my/2-2.png';
import MY_2_3 from './my/2-3.png';
import MY_2_search from './my/2-search.png';
import MY_3_1 from './my/3-1.png';
import MY_3_2 from './my/3-2.png';
import MY_3_3 from './my/3-3.png';
import MY_3_search from './my/3-search.png';

// VN
import VN_1_1 from './vn/1-1.png';
import VN_1_2 from './vn/1-2.png';
import VN_1_3 from './vn/1-3.png';
import VN_1_search from './vn/1-search.png';
import VN_2_1 from './vn/2-1.png';
import VN_2_2 from './vn/2-2.png';
import VN_2_3 from './vn/2-3.png';
import VN_2_search from './vn/2-search.png';
import VN_3_1 from './vn/3-1.png';
import VN_3_2 from './vn/3-2.png';
import VN_3_3 from './vn/3-3.png';
import VN_3_search from './vn/3-search.png';

// SG
import SG_1_1 from './sg/1-1.png';
import SG_1_2 from './sg/1-2.png';
import SG_1_3 from './sg/1-3.png';
import SG_1_search from './sg/1-search.png';
import SG_2_1 from './sg/2-1.png';
import SG_2_2 from './sg/2-2.png';
import SG_2_3 from './sg/2-3.png';
import SG_2_search from './sg/2-search.png';
import SG_3_1 from './sg/3-1.png';
import SG_3_2 from './sg/3-2.png';
import SG_3_3 from './sg/3-3.png';
import SG_3_search from './sg/3-search.png';

import { useAtomValue } from 'jotai';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { Region } from '@lemon8/web-app-shared/i18n';

export const useAssetsCssProperties = (): CSSProperties => {
  const { region } = useAtomValue($Locale);

  const defaultUSValue = {
    '--image-1-1': `url(${US_1_1})`,
    '--image-1-2': `url(${US_1_2})`,
    '--image-1-3': `url(${US_1_3})`,
    '--image-1-search': `url(${US_1_search})`,
    '--image-2-1': `url(${US_2_1})`,
    '--image-2-2': `url(${US_2_2})`,
    '--image-2-3': `url(${US_2_3})`,
    '--image-2-search': `url(${US_2_search})`,
    '--image-3-1': `url(${US_3_1})`,
    '--image-3-2': `url(${US_3_2})`,
    '--image-3-3': `url(${US_3_3})`,
    '--image-3-search': `url(${US_3_search})`,
  };

  switch (region) {
    case Region.us:
      return defaultUSValue as CSSProperties;
    case Region.jp:
      return {
        '--image-1-1': `url(${JP_1_1})`,
        '--image-1-2': `url(${JP_1_2})`,
        '--image-1-3': `url(${JP_1_3})`,
        '--image-1-search': `url(${JP_1_search})`,
        '--image-2-1': `url(${JP_2_1})`,
        '--image-2-2': `url(${JP_2_2})`,
        '--image-2-3': `url(${JP_2_3})`,
        '--image-2-search': `url(${JP_2_search})`,
        '--image-3-1': `url(${JP_3_1})`,
        '--image-3-2': `url(${JP_3_2})`,
        '--image-3-3': `url(${JP_3_3})`,
        '--image-3-search': `url(${JP_3_search})`,
      } as CSSProperties;
    case Region.id:
      return {
        '--image-1-1': `url(${ID_1_1})`,
        '--image-1-2': `url(${ID_1_2})`,
        '--image-1-3': `url(${ID_1_3})`,
        '--image-1-search': `url(${ID_1_search})`,
        '--image-2-1': `url(${ID_2_1})`,
        '--image-2-2': `url(${ID_2_2})`,
        '--image-2-3': `url(${ID_2_3})`,
        '--image-2-search': `url(${ID_2_search})`,
        '--image-3-1': `url(${ID_3_1})`,
        '--image-3-2': `url(${ID_3_2})`,
        '--image-3-3': `url(${ID_3_3})`,
        '--image-3-search': `url(${ID_3_search})`,
      } as CSSProperties;
    case Region.th:
      return {
        '--image-1-1': `url(${TH_1_1})`,
        '--image-1-2': `url(${TH_1_2})`,
        '--image-1-3': `url(${TH_1_3})`,
        '--image-1-search': `url(${TH_1_search})`,
        '--image-2-1': `url(${TH_2_1})`,
        '--image-2-2': `url(${TH_2_2})`,
        '--image-2-3': `url(${TH_2_3})`,
        '--image-2-search': `url(${TH_2_search})`,
        '--image-3-1': `url(${TH_3_1})`,
        '--image-3-2': `url(${TH_3_2})`,
        '--image-3-3': `url(${TH_3_3})`,
        '--image-3-search': `url(${TH_3_search})`,
      } as CSSProperties;
    case Region.my:
      return {
        '--image-1-1': `url(${MY_1_1})`,
        '--image-1-2': `url(${MY_1_2})`,
        '--image-1-3': `url(${MY_1_3})`,
        '--image-1-search': `url(${MY_1_search})`,
        '--image-2-1': `url(${MY_2_1})`,
        '--image-2-2': `url(${MY_2_2})`,
        '--image-2-3': `url(${MY_2_3})`,
        '--image-2-search': `url(${MY_2_search})`,
        '--image-3-1': `url(${MY_3_1})`,
        '--image-3-2': `url(${MY_3_2})`,
        '--image-3-3': `url(${MY_3_3})`,
        '--image-3-search': `url(${MY_3_search})`,
      } as CSSProperties;
    case Region.vn:
      return {
        '--image-1-1': `url(${VN_1_1})`,
        '--image-1-2': `url(${VN_1_2})`,
        '--image-1-3': `url(${VN_1_3})`,
        '--image-1-search': `url(${VN_1_search})`,
        '--image-2-1': `url(${VN_2_1})`,
        '--image-2-2': `url(${VN_2_2})`,
        '--image-2-3': `url(${VN_2_3})`,
        '--image-2-search': `url(${VN_2_search})`,
        '--image-3-1': `url(${VN_3_1})`,
        '--image-3-2': `url(${VN_3_2})`,
        '--image-3-3': `url(${VN_3_3})`,
        '--image-3-search': `url(${VN_3_search})`,
      } as CSSProperties;
    case Region.sg:
      return {
        '--image-1-1': `url(${SG_1_1})`,
        '--image-1-2': `url(${SG_1_2})`,
        '--image-1-3': `url(${SG_1_3})`,
        '--image-1-search': `url(${SG_1_search})`,
        '--image-2-1': `url(${SG_2_1})`,
        '--image-2-2': `url(${SG_2_2})`,
        '--image-2-3': `url(${SG_2_3})`,
        '--image-2-search': `url(${SG_2_search})`,
        '--image-3-1': `url(${SG_3_1})`,
        '--image-3-2': `url(${SG_3_2})`,
        '--image-3-3': `url(${SG_3_3})`,
        '--image-3-search': `url(${SG_3_search})`,
      } as CSSProperties;
    default:
      return defaultUSValue as CSSProperties;
  }
};

export const usePreloadList = (): string[] => {
  const { region } = useAtomValue($Locale);

  switch (region) {
    case Region.jp:
      return [
        JP_1_1,
        JP_1_2,
        JP_1_3,
        JP_1_search,
        JP_2_1,
        JP_2_2,
        JP_2_3,
        JP_2_search,
        JP_3_1,
        JP_3_2,
        JP_3_3,
        JP_3_search,
      ];
    case Region.id:
      return [
        ID_1_1,
        ID_1_2,
        ID_1_3,
        ID_1_search,
        ID_2_1,
        ID_2_2,
        ID_2_3,
        ID_2_search,
        ID_3_1,
        ID_3_2,
        ID_3_3,
        ID_3_search,
      ];
    case Region.th:
      return [
        TH_1_1,
        TH_1_2,
        TH_1_3,
        TH_1_search,
        TH_2_1,
        TH_2_2,
        TH_2_3,
        TH_2_search,
        TH_3_1,
        TH_3_2,
        TH_3_3,
        TH_3_search,
      ];
    case Region.my:
      return [
        MY_1_1,
        MY_1_2,
        MY_1_3,
        MY_1_search,
        MY_2_1,
        MY_2_2,
        MY_2_3,
        MY_2_search,
        MY_3_1,
        MY_3_2,
        MY_3_3,
        MY_3_search,
      ];
    case Region.vn:
      return [
        VN_1_1,
        VN_1_2,
        VN_1_3,
        VN_1_search,
        VN_2_1,
        VN_2_2,
        VN_2_3,
        VN_2_search,
        VN_3_1,
        VN_3_2,
        VN_3_3,
        VN_3_search,
      ];
    case Region.sg:
      return [
        SG_1_1,
        SG_1_2,
        SG_1_3,
        SG_1_search,
        SG_2_1,
        SG_2_2,
        SG_2_3,
        SG_2_search,
        SG_3_1,
        SG_3_2,
        SG_3_3,
        SG_3_search,
      ];
    case Region.us:
    default:
      return [
        US_1_1,
        US_1_2,
        US_1_3,
        US_1_search,
        US_2_1,
        US_2_2,
        US_2_3,
        US_2_search,
        US_3_1,
        US_3_2,
        US_3_3,
        US_3_search,
      ];
  }
};
